import * as React from "react";
import type { SVGProps } from "react";
const SvgArrowGray = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={32}
    height={32}
    fill="none"
    {...props}
  >
    <path
      fill="#fff"
      fillOpacity={0.5}
      fillRule="evenodd"
      d="M19.944 15.057c.52.52.52 1.365 0 1.885l-6 6a1.333 1.333 0 0 1-1.886-1.886L17.115 16l-5.057-5.057a1.333 1.333 0 0 1 1.886-1.885z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgArrowGray;
